// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'bootstrap3/dist/css/bootstrap.css'
import Vue from 'vue'
import App from './App'
//import router from './router'

import Home from './components/pages/index'
import TechnicalSupport from './components/pages/technical_support'
import TechnologySystem from './components/pages/technology_system'
import CustomerCase from './components/pages/customer_case'
import IntelligentDevice from './components/pages/intelligent_device'
// import ResourceInfo from './components/pages/resource_info'
import HaveSug from './components/pages/haveSug'
import Feedback from './components/pages/feedback'

import $ from 'jquery'
import axios from 'axios'
axios.defaults.baseURL = 'http://www.so56.net'
// axios.defaults.baseURL = 'http://192.168.26.33:8080'
import vueAxios from 'vue-axios'
Vue.use(vueAxios, axios)

import 'bootstrap3/dist/js/bootstrap.js'
import './assets/js/scroll.js'

import vueRouter from 'vue-router'

Vue.use(vueRouter)

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// import VueSuperSlide from 'vue-superslide'
// Vue.use(VueSuperSlide)

Vue.config.productionTip = false

const routes = [
	{
		path: '/',
		redirect: '/home'
	},
	{
		path: '/home',
		name: "Home",
		component: Home
	},
	{
		path: '/TechnicalSupport',
		name: "TechnicalSupport",
		component: TechnicalSupport
	},
	{
		path: '/TechnologySystem',
		name: "TechnologySystem",
		component: TechnologySystem
	},
	{
		path: '/CustomerCase',
		name: "CustomerCase",
		component: CustomerCase
	},
	{
		path: '/IntelligentDevice',
		name: "IntelligentDevice",
		component: IntelligentDevice
	},
	// {
	// 	path: '/ResourceInfo',
	// 	name: "ResourceInfo",
	// 	component: ResourceInfo
	// },
  {
  	path: '/HaveSug',
  	name: "HaveSug",
  	component: HaveSug
  },
  {
  	path: '/Feedback',
  	name: "Feedback",
  	component: Feedback
  },
]

const router = new vueRouter({
	routes,
	//mode: 'history',
	linkActiveClass: 'active'
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

//



// WEBPACK FOOTER //
// ./src/main.js